// tslint:disable
import { Injectable } from '@angular/core';

import { DwQuery, DwQueryBuilderGen, DwItem2, DwItemAttributeCollection, DwItemAttribute, DwItemRelationshipCollection, DwItemRelationship, DwItemDetail2, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.37
   Code Gen Name   ProjectKickoff
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     5/24/2024 12:38:37 PM
************************************************/

export enum ProjectKickoffMetaDataItemNames {
    Billing = 'Billing',
    BillingDepartment = 'BillingDepartment',
    Checklist = 'Checklist',
    Escalation = 'Escalation',
    EthosCustomer = 'Ethos_Customer',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberMembership = 'Ethos_JobNumberMembership',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobNumberPriority = 'Ethos_JobNumberPriority',
    EthosOpportunity = 'Ethos_Opportunity',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    KickoffChecklist = 'KickoffChecklist',
    ProjectMilestone = 'ProjectMilestone',
    ProjectsKickoff = 'projects_Kickoff',
    Reporting = 'Reporting',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoProjectKickoff = 'roProjectKickoff',
    Stakeholder = 'Stakeholder',
    TeamAssignment = 'TeamAssignment',
}

export enum ProjectKickoffMetaDataLookups {
    ActiveJobNumberForKickoff = 2934,
    BillingAllItems = 2910,
    BillingDepartmentAllItems = 2924,
    ChecklistAllItems = 2917,
    EmployeesByDeptIncTrainees = 2812,
    EscalationAllItems = 2914,
    EthosCustomerAllItems = 1523,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberEJNPJNFJN = 2869,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberMembershipAllItems = 2867,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobNumberPriorityAllItems = 2866,
    EthosOpportunityAllItems = 1793,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserEmployeeGroups = 2858,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentAllItems = 1391,
    JobNumberActive = 1872,
    JobNumberToCustJobName = 2870,
    KickoffAllItems = 2918,
    KickoffChecklistAllItems = 2915,
    OpportunityByCustomer = 2921,
    OverheadJobNumbers = 1589,
    ProjectKickoffJobNumberFromOpportunity = 2931,
    ProjectKickoffOpportunityWCustomer = 2927,
    ProjectKickoffChecklist = 2929,
    ProjectKickoffCustomers = 2920,
    ProjectMilestoneAllItems = 2909,
    ReportingAllItems = 2912,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoProjectKickoffAllItems = 2935,
    StakeholderAllItems = 2913,
    TeamAssignmentAllItems = 2911,
    WachterDivisions = 1858,
}


// Generated Classes for MetaData service
export class BillingMetaData implements DwItem2<BillingEntity, BillingMetaDataAttributes,BillingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3417;
        this.ItemDetail.itemName='Billing';
        this.ItemDetail.keyName='BillingId';
    }

    CreateEntity(): BillingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BillingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BillingEntity, BillingMetaDataAttributes,BillingMetaDataRelations>(query, this);
    }
     Attributes = new BillingMetaDataAttributes();
     Relations = new BillingMetaDataRelations();

}


export type BillingQueryBuilder = DwQueryBuilderGen<BillingEntity, BillingMetaDataAttributes,BillingMetaDataRelations>


export class BillingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Billing';
    // Attributes
    BillingId = new DwItemAttribute(this.i, 'BillingId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    BillingTypeCv = new DwItemAttribute(this.i, 'BillingTypeCv');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    ParentJobNumberId = new DwItemAttribute(this.i, 'ParentJobNumberId');
    InvoiceFrequencyCv = new DwItemAttribute(this.i, 'InvoiceFrequencyCv');
    EstimatedBillingDate = new DwItemAttribute(this.i, 'EstimatedBillingDate');
    Notes = new DwItemAttribute(this.i, 'Notes');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
    InterdepartmentalBilling = new DwItemAttribute(this.i, 'InterdepartmentalBilling');
}

class BillingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number - Parent Job Number */
            EthosJobNumberByParentJobNumberId = new DwItemRelationship('Ethos_JobNumber|Billing|ParentJobNumberId', 'ParentEthosJobNumber', 'ParentEthosJobNumber');
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Billing|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|Billing|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Billing|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Billing|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
            /** Relation: Billing Department */
            BillingDepartment = new DwItemRelationship('Billing|BillingDepartment|BillingId', 'BillingDepartment', 'BillingDepartment');
    };
export class BillingDepartmentMetaData implements DwItem2<BillingDepartmentEntity, BillingDepartmentMetaDataAttributes,BillingDepartmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3427;
        this.ItemDetail.itemName='BillingDepartment';
        this.ItemDetail.keyName='BillingDeptId';
    }

    CreateEntity(): BillingDepartmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BillingDepartmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BillingDepartmentEntity, BillingDepartmentMetaDataAttributes,BillingDepartmentMetaDataRelations>(query, this);
    }
     Attributes = new BillingDepartmentMetaDataAttributes();
     Relations = new BillingDepartmentMetaDataRelations();

}


export type BillingDepartmentQueryBuilder = DwQueryBuilderGen<BillingDepartmentEntity, BillingDepartmentMetaDataAttributes,BillingDepartmentMetaDataRelations>


export class BillingDepartmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BillingDepartment';
    // Attributes
    BillingDeptId = new DwItemAttribute(this.i, 'BillingDeptId');
    BillingId = new DwItemAttribute(this.i, 'BillingId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class BillingDepartmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Billing */
            Billing = new DwItemRelationship('Billing|BillingDepartment|BillingId', 'Billing', 'Billing');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|BillingDepartment|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|BillingDepartment|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_WachterDepartment|BillingDepartment|WachterDepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class ChecklistMetaData implements DwItem2<ChecklistEntity, ChecklistMetaDataAttributes,ChecklistMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3424;
        this.ItemDetail.itemName='Checklist';
        this.ItemDetail.keyName='ChecklistId';
    }

    CreateEntity(): ChecklistEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ChecklistQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ChecklistEntity, ChecklistMetaDataAttributes,ChecklistMetaDataRelations>(query, this);
    }
     Attributes = new ChecklistMetaDataAttributes();
     Relations = new ChecklistMetaDataRelations();

}


export type ChecklistQueryBuilder = DwQueryBuilderGen<ChecklistEntity, ChecklistMetaDataAttributes,ChecklistMetaDataRelations>


export class ChecklistMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Checklist';
    // Attributes
    ChecklistId = new DwItemAttribute(this.i, 'ChecklistId');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    Item = new DwItemAttribute(this.i, 'Item');
    Number = new DwItemAttribute(this.i, 'Number');
}

class ChecklistMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Checklist|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Checklist|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
            /** Relation: Kickoff Checklist */
            KickoffChecklist = new DwItemRelationship('Checklist|KickoffChecklist|ChecklistId', 'KickoffChecklist', 'KickoffChecklist');
    };
export class EscalationMetaData implements DwItem2<EscalationEntity, EscalationMetaDataAttributes,EscalationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3421;
        this.ItemDetail.itemName='Escalation';
        this.ItemDetail.keyName='EscalationId';
    }

    CreateEntity(): EscalationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EscalationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EscalationEntity, EscalationMetaDataAttributes,EscalationMetaDataRelations>(query, this);
    }
     Attributes = new EscalationMetaDataAttributes();
     Relations = new EscalationMetaDataRelations();

}


export type EscalationQueryBuilder = DwQueryBuilderGen<EscalationEntity, EscalationMetaDataAttributes,EscalationMetaDataRelations>


export class EscalationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Escalation';
    // Attributes
    EscalationId = new DwItemAttribute(this.i, 'EscalationId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    Order = new DwItemAttribute(this.i, 'Order');
    Name = new DwItemAttribute(this.i, 'Name');
    Title = new DwItemAttribute(this.i, 'Title');
    Department = new DwItemAttribute(this.i, 'Department');
    Company = new DwItemAttribute(this.i, 'Company');
    Phone = new DwItemAttribute(this.i, 'Phone');
    Email = new DwItemAttribute(this.i, 'Email');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    Role = new DwItemAttribute(this.i, 'Role');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class EscalationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|Escalation|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Escalation|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Escalation|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
    };
export class EthosCustomerMetaData implements DwItem2<EthosCustomerEntity, EthosCustomerMetaDataAttributes,EthosCustomerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2499;
        this.ItemDetail.itemName='Ethos_Customer';
        this.ItemDetail.keyName='CustomerId';
    }

    CreateEntity(): EthosCustomerEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosCustomerQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosCustomerEntity, EthosCustomerMetaDataAttributes,EthosCustomerMetaDataRelations>(query, this);
    }
     Attributes = new EthosCustomerMetaDataAttributes();
     Relations = new EthosCustomerMetaDataRelations();

}


export type EthosCustomerQueryBuilder = DwQueryBuilderGen<EthosCustomerEntity, EthosCustomerMetaDataAttributes,EthosCustomerMetaDataRelations>


export class EthosCustomerMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Customer';
    // Attributes
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    CustomerName = new DwItemAttribute(this.i, 'CustomerName');
    CustomerShortName = new DwItemAttribute(this.i, 'CustomerShortName');
    Active = new DwItemAttribute(this.i, 'Active');
}

class EthosCustomerMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number - End - Many */
            EthosJobNumberByEndCustomerId = new DwItemRelationship('Ethos_Customer|Ethos_JobNumber|EndCustomerId', 'EndEthosJobNumber', 'EndEthosJobNumber');
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_Customer|Ethos_JobNumber|CustomerId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos Opportunity */
            EthosOpportunity = new DwItemRelationship('Ethos_Customer|Ethos_Opportunity|CustomerId', 'EthosOpportunity', 'EthosOpportunity');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_Customer|Ethos_User|CustomerId', 'EthosUser', 'EthosUser');
    };
export class EthosJobNumberMetaData implements DwItem2<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2375;
        this.ItemDetail.itemName='Ethos_JobNumber';
        this.ItemDetail.keyName='JobNumberId';
    }

    CreateEntity(): EthosJobNumberEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberMetaDataAttributes();
     Relations = new EthosJobNumberMetaDataRelations();

}


export type EthosJobNumberQueryBuilder = DwQueryBuilderGen<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations>


export class EthosJobNumberMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber';
    // Attributes
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    JobNumberStatusWs = new DwItemAttribute(this.i, 'JobNumberStatusWs');
    JobNumberStatus = new DwItemAttribute(this.i, 'JobNumberStatus');
    JobNumber = new DwItemAttribute(this.i, 'JobNumber');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    JobName = new DwItemAttribute(this.i, 'JobName');
    EstimatedStartDate = new DwItemAttribute(this.i, 'EstimatedStartDate');
    EstimatedEndDate = new DwItemAttribute(this.i, 'EstimatedEndDate');
    ProjectMgr1UserId = new DwItemAttribute(this.i, 'ProjectMgr1UserId');
    ProjectMgr2UserId = new DwItemAttribute(this.i, 'ProjectMgr2UserId');
    AsstProjectMgrUserId = new DwItemAttribute(this.i, 'AsstProjectMgrUserId');
    SeniorMgrUserId = new DwItemAttribute(this.i, 'SeniorMgrUserId');
    LeadTech1UserId = new DwItemAttribute(this.i, 'LeadTech1UserId');
    LeadTech2UserId = new DwItemAttribute(this.i, 'LeadTech2UserId');
    InvoiceApproval1UserId = new DwItemAttribute(this.i, 'InvoiceApproval1UserId');
    InvoiceApproval2UserId = new DwItemAttribute(this.i, 'InvoiceApproval2UserId');
    ForecastStatusCv = new DwItemAttribute(this.i, 'ForecastStatusCv');
    ForecastStatus = new DwItemAttribute(this.i, 'ForecastStatus');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    CustomerName = new DwItemAttribute(this.i, 'CustomerName');
    CustomerShortName = new DwItemAttribute(this.i, 'CustomerShortName');
    BillingInstructions = new DwItemAttribute(this.i, 'BillingInstructions');
    ChangeOrderProcessInstructions = new DwItemAttribute(this.i, 'ChangeOrderProcessInstructions');
    PartialBilling = new DwItemAttribute(this.i, 'PartialBilling');
    FinalInvoiceDate = new DwItemAttribute(this.i, 'FinalInvoiceDate');
    InvoiceDeliveryTypeData = new DwItemAttribute(this.i, 'InvoiceDeliveryTypeData');
    InvoiceDeliveryTypeCV = new DwItemAttribute(this.i, 'InvoiceDeliveryTypeCV');
    OpportunityId = new DwItemAttribute(this.i, 'OpportunityId');
    EndCustomerId = new DwItemAttribute(this.i, 'EndCustomerId');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    JobNumberTypeCv = new DwItemAttribute(this.i, 'JobNumberTypeCv');
}

class EthosJobNumberMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Customer - End Customer */
            EthosCustomerByEndCustomerId = new DwItemRelationship('Ethos_Customer|Ethos_JobNumber|EndCustomerId', 'EndEthosCustomer', 'EndEthosCustomer');
            /** Relation: Customer */
            EthosCustomer = new DwItemRelationship('Ethos_Customer|Ethos_JobNumber|CustomerId', 'EthosCustomer', 'EthosCustomer');
            /** Relation: Ethos Opportunity */
            EthosOpportunity = new DwItemRelationship('Opportunity-JobNumber', 'EthosOpportunity', 'EthosOpportunity');
            /** Relation: Ethos User - Project Mgr1 User */
            EthosUserByProjectMgr1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr1UserId', 'ProjectMgr1EthosUser', 'ProjectMgr1EthosUser');
            /** Relation: Ethos User - Project Mgr2 User */
            EthosUserByProjectMgr2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr2UserId', 'ProjectMgr2EthosUser', 'ProjectMgr2EthosUser');
            /** Relation: Ethos User - Asst Project Mgr User */
            EthosUserByAsstProjectMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId', 'AsstProjectMgrEthosUser', 'AsstProjectMgrEthosUser');
            /** Relation: Ethos User - Senior Mgr User */
            EthosUserBySeniorMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|SeniorMgrUserId', 'SeniorMgrEthosUser', 'SeniorMgrEthosUser');
            /** Relation: Ethos User - Lead Tech1 User */
            EthosUserByLeadTech1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech1UserId', 'LeadTech1EthosUser', 'LeadTech1EthosUser');
            /** Relation: Ethos User - Lead Tech2 User */
            EthosUserByLeadTech2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech2UserId', 'LeadTech2EthosUser', 'LeadTech2EthosUser');
            /** Relation: Ethos User - Invoice Approval1 User */
            EthosUserByInvoiceApproval1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId', 'InvoiceApproval1EthosUser', 'InvoiceApproval1EthosUser');
            /** Relation: Ethos User - Invoice Approval2 User */
            EthosUserByInvoiceApproval2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId', 'InvoiceApproval2EthosUser', 'InvoiceApproval2EthosUser');
            /** Relation: Billing - Parent - Many */
            BillingByParentJobNumberId = new DwItemRelationship('Ethos_JobNumber|Billing|ParentJobNumberId', 'ParentBilling', 'ParentBilling');
            /** Relation: Billing */
            Billing = new DwItemRelationship('Ethos_JobNumber|Billing|JobNumberId', 'Billing', 'Billing');
            /** Relation: Job Number Forecast */
            EthosJobNumberForecast = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId', 'EthosJobNumberForecast', 'EthosJobNumberForecast');
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId', 'EthosJobNumberMembership', 'EthosJobNumberMembership');
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId', 'EthosJobNumberPhase', 'EthosJobNumberPhase');
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId', 'EthosJobNumberPriority', 'EthosJobNumberPriority');
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId = new DwItemRelationship('JobNumber->ProjectManager', 'UserIdEthosUser', 'UserIdEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId', 'EthosWachterDepartment', 'EthosWachterDepartment');
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('Ethos_JobNumber|projects_Kickoff|JobNumberId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ro Project Kickoff */
            RoProjectKickoff = new DwItemRelationship('roProjectKickoff|JobMembership', 'RoProjectKickoff', 'RoProjectKickoff');
    };
export class EthosJobNumberForecastMetaData implements DwItem2<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2374;
        this.ItemDetail.itemName='Ethos_JobNumberForecast';
        this.ItemDetail.keyName='JobNumberForecastId';
    }

    CreateEntity(): EthosJobNumberForecastEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberForecastQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberForecastMetaDataAttributes();
     Relations = new EthosJobNumberForecastMetaDataRelations();

}


export type EthosJobNumberForecastQueryBuilder = DwQueryBuilderGen<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations>


export class EthosJobNumberForecastMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast';
    // Attributes
    JobNumberForecastId = new DwItemAttribute(this.i, 'JobNumberForecastId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    YeProjectedCosts = new DwItemAttribute(this.i, 'YeProjectedCosts');
    YeProjectedRevenue = new DwItemAttribute(this.i, 'YeProjectedRevenue');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Notes = new DwItemAttribute(this.i, 'Notes');
    NoteAgingOverSixtyDays = new DwItemAttribute(this.i, 'NoteAgingOverSixtyDays');
    NoteOverUnderBilling = new DwItemAttribute(this.i, 'NoteOverUnderBilling');
    NoteLowForecastedGpm = new DwItemAttribute(this.i, 'NoteLowForecastedGpm');
    NoteChangedGpm = new DwItemAttribute(this.i, 'NoteChangedGpm');
    AXIntegrationID = new DwItemAttribute(this.i, 'AXIntegrationID');
    TotalForecastRevenue = new DwItemAttribute(this.i, 'TotalForecastRevenue');
    TotalForecastCost = new DwItemAttribute(this.i, 'TotalForecastCost');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
}

class EthosJobNumberForecastMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|CreatedBy', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|ModifiedBy', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
    };
export class EthosJobNumberMembershipMetaData implements DwItem2<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2794;
        this.ItemDetail.itemName='Ethos_JobNumberMembership';
        this.ItemDetail.keyName='JobNumberMembershipId';
    }

    CreateEntity(): EthosJobNumberMembershipEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberMembershipQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberMembershipMetaDataAttributes();
     Relations = new EthosJobNumberMembershipMetaDataRelations();

}


export type EthosJobNumberMembershipQueryBuilder = DwQueryBuilderGen<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations>


export class EthosJobNumberMembershipMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberMembership';
    // Attributes
    JobNumberMembershipId = new DwItemAttribute(this.i, 'JobNumberMembershipId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
}

class EthosJobNumberMembershipMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_JobNumberMembership|UserId', 'EthosUser', 'EthosUser');
    };
export class EthosJobNumberPhaseMetaData implements DwItem2<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2552;
        this.ItemDetail.itemName='Ethos_JobNumberPhase';
        this.ItemDetail.keyName='JobNumberPhaseId';
    }

    CreateEntity(): EthosJobNumberPhaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberPhaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberPhaseMetaDataAttributes();
     Relations = new EthosJobNumberPhaseMetaDataRelations();

}


export type EthosJobNumberPhaseQueryBuilder = DwQueryBuilderGen<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations>


export class EthosJobNumberPhaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase';
    // Attributes
    JobNumberPhaseId = new DwItemAttribute(this.i, 'JobNumberPhaseId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    PhaseCode = new DwItemAttribute(this.i, 'PhaseCode');
    PhaseDescription = new DwItemAttribute(this.i, 'PhaseDescription');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsVisible = new DwItemAttribute(this.i, 'IsVisible');
    IsOnSite = new DwItemAttribute(this.i, 'IsOnSite');
    IsEstimate = new DwItemAttribute(this.i, 'IsEstimate');
    JobNumberPhaseStatusWs = new DwItemAttribute(this.i, 'JobNumberPhaseStatusWs');
    WorkflowStatusDisplay = new DwItemAttribute(this.i, 'WorkflowStatusDisplay');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
}

class EthosJobNumberPhaseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class EthosJobNumberPriorityMetaData implements DwItem2<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2792;
        this.ItemDetail.itemName='Ethos_JobNumberPriority';
        this.ItemDetail.keyName='JobNumberPriorityId';
    }

    CreateEntity(): EthosJobNumberPriorityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberPriorityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberPriorityMetaDataAttributes();
     Relations = new EthosJobNumberPriorityMetaDataRelations();

}


export type EthosJobNumberPriorityQueryBuilder = DwQueryBuilderGen<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations>


export class EthosJobNumberPriorityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPriority';
    // Attributes
    JobNumberPriorityId = new DwItemAttribute(this.i, 'JobNumberPriorityId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    PriorityName = new DwItemAttribute(this.i, 'PriorityName');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    ResponseTimeInHours = new DwItemAttribute(this.i, 'ResponseTimeInHours');
    StraightHourlyBillingRate = new DwItemAttribute(this.i, 'StraightHourlyBillingRate');
    OvertimeHourlyBillingRate = new DwItemAttribute(this.i, 'OvertimeHourlyBillingRate');
    HolidayHourlyBillingRate = new DwItemAttribute(this.i, 'HolidayHourlyBillingRate');
    TravelHourlyBillingRate = new DwItemAttribute(this.i, 'TravelHourlyBillingRate');
    MileageBillingRate = new DwItemAttribute(this.i, 'MileageBillingRate');
    MaxTravelInHours = new DwItemAttribute(this.i, 'MaxTravelInHours');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    TripCharge = new DwItemAttribute(this.i, 'TripCharge');
    ExpediteFee = new DwItemAttribute(this.i, 'ExpediteFee');
    IsEscalationEnabled = new DwItemAttribute(this.i, 'IsEscalationEnabled');
    SendPriorityNotification = new DwItemAttribute(this.i, 'SendPriorityNotification');
}

class EthosJobNumberPriorityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
    };
export class EthosOpportunityMetaData implements DwItem2<EthosOpportunityEntity, EthosOpportunityMetaDataAttributes,EthosOpportunityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2693;
        this.ItemDetail.itemName='Ethos_Opportunity';
        this.ItemDetail.keyName='OpportunityId';
    }

    CreateEntity(): EthosOpportunityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosOpportunityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosOpportunityEntity, EthosOpportunityMetaDataAttributes,EthosOpportunityMetaDataRelations>(query, this);
    }
     Attributes = new EthosOpportunityMetaDataAttributes();
     Relations = new EthosOpportunityMetaDataRelations();

}


export type EthosOpportunityQueryBuilder = DwQueryBuilderGen<EthosOpportunityEntity, EthosOpportunityMetaDataAttributes,EthosOpportunityMetaDataRelations>


export class EthosOpportunityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Opportunity';
    // Attributes
    OpportunityId = new DwItemAttribute(this.i, 'OpportunityId');
    OpportunityStatusWs = new DwItemAttribute(this.i, 'OpportunityStatusWs');
    OpportunityName = new DwItemAttribute(this.i, 'OpportunityName');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    ProjectManagerUserId = new DwItemAttribute(this.i, 'ProjectManagerUserId');
    OpportunityManagerUserId = new DwItemAttribute(this.i, 'OpportunityManagerUserId');
    ProjectStatusWs = new DwItemAttribute(this.i, 'ProjectStatusWs');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    StopDate = new DwItemAttribute(this.i, 'StopDate');
}

class EthosOpportunityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Customer */
            EthosCustomer = new DwItemRelationship('Ethos_Customer|Ethos_Opportunity|CustomerId', 'EthosCustomer', 'EthosCustomer');
            /** Relation: Ethos User - Opportunity Manager User */
            EthosUserByOpportunityManagerUserId = new DwItemRelationship('Ethos_User|Ethos_Opportunity|OpportunityManagerUserId', 'OpportunityManagerEthosUser', 'OpportunityManagerEthosUser');
            /** Relation: Ethos User - Project Manager User */
            EthosUserByProjectManagerUserId = new DwItemRelationship('Ethos_User|Ethos_Opportunity|ProjectManagerUserId', 'ProjectManagerEthosUser', 'ProjectManagerEthosUser');
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Opportunity-JobNumber', 'EthosJobNumber', 'EthosJobNumber');
    };
export class EthosUserMetaData implements DwItem2<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2413;
        this.ItemDetail.itemName='Ethos_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): EthosUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserMetaDataAttributes();
     Relations = new EthosUserMetaDataRelations();

}


export type EthosUserQueryBuilder = DwQueryBuilderGen<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations>


export class EthosUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    SubcontractorId = new DwItemAttribute(this.i, 'SubcontractorId');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    IsVaxxed = new DwItemAttribute(this.i, 'isVaxxed');
}

class EthosUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Customer */
            EthosCustomer = new DwItemRelationship('Ethos_Customer|Ethos_User|CustomerId', 'EthosCustomer', 'EthosCustomer');
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId = new DwItemRelationship('JobNumber->ProjectManager', 'UserIdEthosJobNumber', 'UserIdEthosJobNumber');
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId = new DwItemRelationship('Supervisor_User', 'SupervisorEthosUser', 'SupervisorEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
            /** Relation: Billing - Createdby - Many */
            BillingByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Billing|CreatedbyEthos_UserId', 'CreatedbyEthosBilling', 'CreatedbyEthosBilling');
            /** Relation: Billing - Modified By - Many */
            BillingByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Billing|ModifiedByEthos_UserId', 'ModifiedByEthosBilling', 'ModifiedByEthosBilling');
            /** Relation: Billing Department - Createdby - Many */
            BillingDepartmentByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|BillingDepartment|CreatedbyEthos_UserId', 'CreatedbyEthosBillingDepartment', 'CreatedbyEthosBillingDepartment');
            /** Relation: Billing Department - Modified By - Many */
            BillingDepartmentByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|BillingDepartment|ModifiedByEthos_UserId', 'ModifiedByEthosBillingDepartment', 'ModifiedByEthosBillingDepartment');
            /** Relation: Checklist - Createdby - Many */
            ChecklistByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Checklist|CreatedbyEthos_UserId', 'CreatedbyEthosChecklist', 'CreatedbyEthosChecklist');
            /** Relation: Checklist - Modified By - Many */
            ChecklistByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Checklist|ModifiedByEthos_UserId', 'ModifiedByEthosChecklist', 'ModifiedByEthosChecklist');
            /** Relation: Escalation - Createdby - Many */
            EscalationByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Escalation|CreatedbyEthos_UserId', 'CreatedbyEthosEscalation', 'CreatedbyEthosEscalation');
            /** Relation: Escalation - Modified By - Many */
            EscalationByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Escalation|ModifiedByEthos_UserId', 'ModifiedByEthosEscalation', 'ModifiedByEthosEscalation');
            /** Relation: Job Number - Project Mgr1 - Many */
            EthosJobNumberByProjectMgr1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr1UserId', 'ProjectMgr1EthosJobNumber', 'ProjectMgr1EthosJobNumber');
            /** Relation: Job Number - Project Mgr2 - Many */
            EthosJobNumberByProjectMgr2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr2UserId', 'ProjectMgr2EthosJobNumber', 'ProjectMgr2EthosJobNumber');
            /** Relation: Job Number - Asst Project Mgr - Many */
            EthosJobNumberByAsstProjectMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId', 'AsstProjectMgrEthosJobNumber', 'AsstProjectMgrEthosJobNumber');
            /** Relation: Job Number - Senior Mgr - Many */
            EthosJobNumberBySeniorMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|SeniorMgrUserId', 'SeniorMgrEthosJobNumber', 'SeniorMgrEthosJobNumber');
            /** Relation: Job Number - Lead Tech1 - Many */
            EthosJobNumberByLeadTech1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech1UserId', 'LeadTech1EthosJobNumber', 'LeadTech1EthosJobNumber');
            /** Relation: Job Number - Lead Tech2 - Many */
            EthosJobNumberByLeadTech2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech2UserId', 'LeadTech2EthosJobNumber', 'LeadTech2EthosJobNumber');
            /** Relation: Job Number - Invoice Approval1 - Many */
            EthosJobNumberByInvoiceApproval1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId', 'InvoiceApproval1EthosJobNumber', 'InvoiceApproval1EthosJobNumber');
            /** Relation: Job Number - Invoice Approval2 - Many */
            EthosJobNumberByInvoiceApproval2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId', 'InvoiceApproval2EthosJobNumber', 'InvoiceApproval2EthosJobNumber');
            /** Relation: Job Number Forecast - Created By - Many */
            EthosJobNumberForecastByCreatedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|CreatedBy', 'CreatedByEthosJobNumberForecast', 'CreatedByEthosJobNumberForecast');
            /** Relation: Job Number Forecast - Modified By - Many */
            EthosJobNumberForecastByModifiedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|ModifiedBy', 'ModifiedByEthosJobNumberForecast', 'ModifiedByEthosJobNumberForecast');
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership = new DwItemRelationship('Ethos_User|Ethos_JobNumberMembership|UserId', 'EthosJobNumberMembership', 'EthosJobNumberMembership');
            /** Relation: Ethos Job Number Priority - Created By - Many */
            EthosJobNumberPriorityByCreatedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|CreatedByUserId', 'CreatedByEthosJobNumberPriority', 'CreatedByEthosJobNumberPriority');
            /** Relation: Ethos Job Number Priority - Modified By - Many */
            EthosJobNumberPriorityByModifiedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId', 'ModifiedByEthosJobNumberPriority', 'ModifiedByEthosJobNumberPriority');
            /** Relation: Ethos Opportunity - Opportunity Manager - Many */
            EthosOpportunityByOpportunityManagerUserId = new DwItemRelationship('Ethos_User|Ethos_Opportunity|OpportunityManagerUserId', 'OpportunityManagerEthosOpportunity', 'OpportunityManagerEthosOpportunity');
            /** Relation: Ethos Opportunity - Project Manager - Many */
            EthosOpportunityByProjectManagerUserId = new DwItemRelationship('Ethos_User|Ethos_Opportunity|ProjectManagerUserId', 'ProjectManagerEthosOpportunity', 'ProjectManagerEthosOpportunity');
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_UserDiff|Ethos_UserId', 'EthosEthosUserDiff', 'EthosEthosUserDiff');
            /** Relation: User Skill */
            EthosUserSkill = new DwItemRelationship('Ethos_User|Ethos_UserSkill|UserId', 'EthosUserSkill', 'EthosUserSkill');
            /** Relation: Wachter Department - Department Director - Many */
            EthosWachterDepartmentByDepartmentDirectorUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId', 'DepartmentDirectorEthosWachterDepartment', 'DepartmentDirectorEthosWachterDepartment');
            /** Relation: Wachter Department - Department Manager - Many */
            EthosWachterDepartmentByDepartmentManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId', 'DepartmentManagerEthosWachterDepartment', 'DepartmentManagerEthosWachterDepartment');
            /** Relation: Wachter Department - Department Asst Manager - Many */
            EthosWachterDepartmentByDepartmentAsstManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId', 'DepartmentAsstManagerEthosWachterDepartment', 'DepartmentAsstManagerEthosWachterDepartment');
            /** Relation: Kickoff - Createdby - Many */
            ProjectsKickoffByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|CreatedbyEthos_UserId', 'CreatedbyEthosProjectsKickoff', 'CreatedbyEthosProjectsKickoff');
            /** Relation: Kickoff - Modified By - Many */
            ProjectsKickoffByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|ModifiedByEthos_UserId', 'ModifiedByEthosProjectsKickoff', 'ModifiedByEthosProjectsKickoff');
            /** Relation: Kickoff - Lead Tech - Many */
            ProjectsKickoffByLeadTechUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|LeadTechUserId', 'LeadTechProjectsKickoff', 'LeadTechProjectsKickoff');
            /** Relation: Kickoff Checklist - Createdby - Many */
            KickoffChecklistByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|KickoffChecklist|CreatedbyEthos_UserId', 'CreatedbyEthosKickoffChecklist', 'CreatedbyEthosKickoffChecklist');
            /** Relation: Kickoff Checklist - Modified By - Many */
            KickoffChecklistByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|KickoffChecklist|ModifiedByEthos_UserId', 'ModifiedByEthosKickoffChecklist', 'ModifiedByEthosKickoffChecklist');
            /** Relation: Project Milestone - Createdby - Many */
            ProjectMilestoneByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|ProjectMilestone|CreatedbyEthos_UserId', 'CreatedbyEthosProjectMilestone', 'CreatedbyEthosProjectMilestone');
            /** Relation: Project Milestone - Modified By - Many */
            ProjectMilestoneByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|ProjectMilestone|ModifiedByEthos_UserId', 'ModifiedByEthosProjectMilestone', 'ModifiedByEthosProjectMilestone');
            /** Relation: Reporting - Createdby - Many */
            ReportingByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Reporting|CreatedbyEthos_UserId', 'CreatedbyEthosReporting', 'CreatedbyEthosReporting');
            /** Relation: Reporting - Modified By - Many */
            ReportingByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Reporting|ModifiedByEthos_UserId', 'ModifiedByEthosReporting', 'ModifiedByEthosReporting');
            /** Relation: Ro Ethos User */
            RoEthosUser = new DwItemRelationship('Ethos_User|roEthos_User|UserId', 'RoEthosUser', 'RoEthosUser');
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId = new DwItemRelationship('Ethos_User|roEthos_User|SupervisorUserId', 'SupervisorRoEthosUser', 'SupervisorRoEthosUser');
            /** Relation: Stakeholder - Createdby - Many */
            StakeholderByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Stakeholder|CreatedbyEthos_UserId', 'CreatedbyEthosStakeholder', 'CreatedbyEthosStakeholder');
            /** Relation: Stakeholder - Modified By - Many */
            StakeholderByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Stakeholder|ModifiedByEthos_UserId', 'ModifiedByEthosStakeholder', 'ModifiedByEthosStakeholder');
    };
export class EthosUserDiffMetaData implements DwItem2<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2572;
        this.ItemDetail.itemName='Ethos_UserDiff';
        this.ItemDetail.keyName='Ethos_UserDiffId';
    }

    CreateEntity(): EthosUserDiffEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserDiffQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserDiffMetaDataAttributes();
     Relations = new EthosUserDiffMetaDataRelations();

}


export type EthosUserDiffQueryBuilder = DwQueryBuilderGen<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations>


export class EthosUserDiffMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff';
    // Attributes
    EthosUserDiffId = new DwItemAttribute(this.i, 'Ethos_UserDiffId');
    EthosUserId = new DwItemAttribute(this.i, 'Ethos_UserId');
    FieldName = new DwItemAttribute(this.i, 'FieldName');
    OldValue = new DwItemAttribute(this.i, 'OldValue');
    NewValue = new DwItemAttribute(this.i, 'NewValue');
    ChangedDateTime = new DwItemAttribute(this.i, 'ChangedDateTime');
}

class EthosUserDiffMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_UserDiff|Ethos_UserId', 'EthosEthosUser', 'EthosEthosUser');
    };
export class EthosUserSkillMetaData implements DwItem2<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2410;
        this.ItemDetail.itemName='Ethos_UserSkill';
        this.ItemDetail.keyName='UserSkillId';
    }

    CreateEntity(): EthosUserSkillEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserSkillQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserSkillMetaDataAttributes();
     Relations = new EthosUserSkillMetaDataRelations();

}


export type EthosUserSkillQueryBuilder = DwQueryBuilderGen<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations>


export class EthosUserSkillMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill';
    // Attributes
    UserSkillId = new DwItemAttribute(this.i, 'UserSkillId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    SkillCv = new DwItemAttribute(this.i, 'SkillCv');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Display = new DwItemAttribute(this.i, 'Display');
}

class EthosUserSkillMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_UserSkill|UserId', 'EthosUser', 'EthosUser');
    };
export class EthosWachterDepartmentMetaData implements DwItem2<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2388;
        this.ItemDetail.itemName='Ethos_WachterDepartment';
        this.ItemDetail.keyName='WachterDepartmentId';
    }

    CreateEntity(): EthosWachterDepartmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosWachterDepartmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations>(query, this);
    }
     Attributes = new EthosWachterDepartmentMetaDataAttributes();
     Relations = new EthosWachterDepartmentMetaDataRelations();

}


export type EthosWachterDepartmentQueryBuilder = DwQueryBuilderGen<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations>


export class EthosWachterDepartmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment';
    // Attributes
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    DepartmentTypeCv = new DwItemAttribute(this.i, 'DepartmentTypeCv');
    DepartmentTypeMeaning = new DwItemAttribute(this.i, 'DepartmentTypeMeaning');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    DepartmentDirectorUserId = new DwItemAttribute(this.i, 'DepartmentDirectorUserId');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    DepartmentManagerUserId = new DwItemAttribute(this.i, 'DepartmentManagerUserId');
    DepartmentAsstManagerUserId = new DwItemAttribute(this.i, 'DepartmentAsstManagerUserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    AxIntegrationId = new DwItemAttribute(this.i, 'AxIntegrationId');
    JobNumberPhaseId = new DwItemAttribute(this.i, 'JobNumberPhaseId');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
}

class EthosWachterDepartmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase = new DwItemRelationship('Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId', 'EthosJobNumberPhase', 'EthosJobNumberPhase');
            /** Relation: Ethos User - Department Director User */
            EthosUserByDepartmentDirectorUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId', 'DepartmentDirectorEthosUser', 'DepartmentDirectorEthosUser');
            /** Relation: Ethos User - Department Manager User */
            EthosUserByDepartmentManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId', 'DepartmentManagerEthosUser', 'DepartmentManagerEthosUser');
            /** Relation: Ethos User - Department Asst Manager User */
            EthosUserByDepartmentAsstManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId', 'DepartmentAsstManagerEthosUser', 'DepartmentAsstManagerEthosUser');
            /** Relation: Billing Department */
            BillingDepartment = new DwItemRelationship('Ethos_WachterDepartment|BillingDepartment|WachterDepartmentId', 'BillingDepartment', 'BillingDepartment');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentId', 'EthosUser', 'EthosUser');
            /** Relation: Ro Ethos User */
            RoEthosUser = new DwItemRelationship('Ethos_WachterDepartment|roEthos_User|WachterDepartmentId', 'RoEthosUser', 'RoEthosUser');
    };
export class ProjectsKickoffMetaData implements DwItem2<ProjectsKickoffEntity, ProjectsKickoffMetaDataAttributes,ProjectsKickoffMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3425;
        this.ItemDetail.itemName='projects_Kickoff';
        this.ItemDetail.keyName='KickoffId';
    }

    CreateEntity(): ProjectsKickoffEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProjectsKickoffQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProjectsKickoffEntity, ProjectsKickoffMetaDataAttributes,ProjectsKickoffMetaDataRelations>(query, this);
    }
     Attributes = new ProjectsKickoffMetaDataAttributes();
     Relations = new ProjectsKickoffMetaDataRelations();

}


export type ProjectsKickoffQueryBuilder = DwQueryBuilderGen<ProjectsKickoffEntity, ProjectsKickoffMetaDataAttributes,ProjectsKickoffMetaDataRelations>


export class ProjectsKickoffMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'projects_Kickoff';
    // Attributes
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    LeadTimeWts = new DwItemAttribute(this.i, 'LeadTimeWts');
    StageTime = new DwItemAttribute(this.i, 'StageTime');
    ConfigurationTime = new DwItemAttribute(this.i, 'ConfigurationTime');
    CustomerSpoc = new DwItemAttribute(this.i, 'CustomerSpoc');
    FollowUpMeetings = new DwItemAttribute(this.i, 'FollowUpMeetings');
    Ppe = new DwItemAttribute(this.i, 'Ppe');
    SpecialRequirements = new DwItemAttribute(this.i, 'SpecialRequirements');
    QualityProgramDetails = new DwItemAttribute(this.i, 'QualityProgramDetails');
    Scope = new DwItemAttribute(this.i, 'Scope');
    Deliverables = new DwItemAttribute(this.i, 'Deliverables');
    RequiresEquipOrValidation = new DwItemAttribute(this.i, 'RequiresEquipOrValidation');
    ValidationNotes = new DwItemAttribute(this.i, 'ValidationNotes');
    ChangeOrderPlan = new DwItemAttribute(this.i, 'ChangeOrderPlan');
    CopResponsibility = new DwItemAttribute(this.i, 'CopResponsibility');
    HelpDesk = new DwItemAttribute(this.i, 'HelpDesk');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    CompletionDate = new DwItemAttribute(this.i, 'CompletionDate');
    IsCriticalCare = new DwItemAttribute(this.i, 'IsCriticalCare');
    ExternalDueDate = new DwItemAttribute(this.i, 'ExternalDueDate');
    PermittingProcess = new DwItemAttribute(this.i, 'PermittingProcess');
    BudgetHours = new DwItemAttribute(this.i, 'BudgetHours');
    IsLicensedRequired = new DwItemAttribute(this.i, 'IsLicensedRequired');
    LeadTechUserId = new DwItemAttribute(this.i, 'LeadTechUserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    ParentKickoffId = new DwItemAttribute(this.i, 'ParentKickoffId');
    LicensingRequired = new DwItemAttribute(this.i, 'LicensingRequired');
    HelpContactDetails = new DwItemAttribute(this.i, 'HelpContactDetails');
}

class ProjectsKickoffMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|projects_Kickoff|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Kickoff - Parent Kickoff - One */
            ProjectsKickoffByParentKickoffId = new DwItemRelationship('projects_Kickoff|projects_Kickoff|ParentKickoffId', 'ParentProjectsKickoff', 'ParentProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
            /** Relation: Ethos User - Lead Tech User */
            EthosUserByLeadTechUserId = new DwItemRelationship('Ethos_User|projects_Kickoff|LeadTechUserId', 'LeadTechEthosUser', 'LeadTechEthosUser');
            /** Relation: Billing */
            Billing = new DwItemRelationship('projects_Kickoff|Billing|KickoffId', 'Billing', 'Billing');
            /** Relation: Escalation */
            Escalation = new DwItemRelationship('projects_Kickoff|Escalation|KickoffId', 'Escalation', 'Escalation');
            /** Relation: Kickoff Checklist */
            KickoffChecklist = new DwItemRelationship('projects_Kickoff|KickoffChecklist|KickoffId', 'KickoffChecklist', 'KickoffChecklist');
            /** Relation: Project Milestone */
            ProjectMilestone = new DwItemRelationship('projects_Kickoff|ProjectMilestone|KickoffId', 'ProjectMilestone', 'ProjectMilestone');
            /** Relation: Reporting */
            Reporting = new DwItemRelationship('projects_Kickoff|Reporting|KickoffId', 'Reporting', 'Reporting');
            /** Relation: Ro Project Kickoff */
            RoProjectKickoff = new DwItemRelationship('roProjectKickoff|Project_Kickoff|KickoffId', 'RoProjectKickoff', 'RoProjectKickoff');
            /** Relation: Stakeholder */
            Stakeholder = new DwItemRelationship('projects_Kickoff|Stakeholder|KickoffId', 'Stakeholder', 'Stakeholder');
            /** Relation: Team Assignment */
            TeamAssignment = new DwItemRelationship('projects_Kickoff|TeamAssignment|KickoffId', 'TeamAssignment', 'TeamAssignment');
    };
export class KickoffChecklistMetaData implements DwItem2<KickoffChecklistEntity, KickoffChecklistMetaDataAttributes,KickoffChecklistMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3422;
        this.ItemDetail.itemName='KickoffChecklist';
        this.ItemDetail.keyName='KickoffChecklistId';
    }

    CreateEntity(): KickoffChecklistEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): KickoffChecklistQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<KickoffChecklistEntity, KickoffChecklistMetaDataAttributes,KickoffChecklistMetaDataRelations>(query, this);
    }
     Attributes = new KickoffChecklistMetaDataAttributes();
     Relations = new KickoffChecklistMetaDataRelations();

}


export type KickoffChecklistQueryBuilder = DwQueryBuilderGen<KickoffChecklistEntity, KickoffChecklistMetaDataAttributes,KickoffChecklistMetaDataRelations>


export class KickoffChecklistMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'KickoffChecklist';
    // Attributes
    KickoffChecklistId = new DwItemAttribute(this.i, 'KickoffChecklistId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    ChecklistId = new DwItemAttribute(this.i, 'ChecklistId');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class KickoffChecklistMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Checklist */
            Checklist = new DwItemRelationship('Checklist|KickoffChecklist|ChecklistId', 'Checklist', 'Checklist');
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|KickoffChecklist|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|KickoffChecklist|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|KickoffChecklist|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
    };
export class ProjectMilestoneMetaData implements DwItem2<ProjectMilestoneEntity, ProjectMilestoneMetaDataAttributes,ProjectMilestoneMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3416;
        this.ItemDetail.itemName='ProjectMilestone';
        this.ItemDetail.keyName='ProjectMilestoneId';
    }

    CreateEntity(): ProjectMilestoneEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProjectMilestoneQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProjectMilestoneEntity, ProjectMilestoneMetaDataAttributes,ProjectMilestoneMetaDataRelations>(query, this);
    }
     Attributes = new ProjectMilestoneMetaDataAttributes();
     Relations = new ProjectMilestoneMetaDataRelations();

}


export type ProjectMilestoneQueryBuilder = DwQueryBuilderGen<ProjectMilestoneEntity, ProjectMilestoneMetaDataAttributes,ProjectMilestoneMetaDataRelations>


export class ProjectMilestoneMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProjectMilestone';
    // Attributes
    ProjectMilestoneId = new DwItemAttribute(this.i, 'ProjectMilestoneId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    Name = new DwItemAttribute(this.i, 'Name');
    Description = new DwItemAttribute(this.i, 'Description');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class ProjectMilestoneMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|ProjectMilestone|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|ProjectMilestone|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|ProjectMilestone|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
    };
export class ReportingMetaData implements DwItem2<ReportingEntity, ReportingMetaDataAttributes,ReportingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3419;
        this.ItemDetail.itemName='Reporting';
        this.ItemDetail.keyName='ReportingId';
    }

    CreateEntity(): ReportingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReportingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReportingEntity, ReportingMetaDataAttributes,ReportingMetaDataRelations>(query, this);
    }
     Attributes = new ReportingMetaDataAttributes();
     Relations = new ReportingMetaDataRelations();

}


export type ReportingQueryBuilder = DwQueryBuilderGen<ReportingEntity, ReportingMetaDataAttributes,ReportingMetaDataRelations>


export class ReportingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Reporting';
    // Attributes
    ReportingId = new DwItemAttribute(this.i, 'ReportingId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    Name = new DwItemAttribute(this.i, 'Name');
    Owner = new DwItemAttribute(this.i, 'Owner');
    Recipient = new DwItemAttribute(this.i, 'Recipient');
    Contents = new DwItemAttribute(this.i, 'Contents');
    Frequency = new DwItemAttribute(this.i, 'Frequency');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class ReportingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|Reporting|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Reporting|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Reporting|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
    };
export class RoEthosUserMetaData implements DwItem2<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2419;
        this.ItemDetail.itemName='roEthos_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): RoEthosUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoEthosUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations>(query, this);
    }
     Attributes = new RoEthosUserMetaDataAttributes();
     Relations = new RoEthosUserMetaDataRelations();

}


export type RoEthosUserQueryBuilder = DwQueryBuilderGen<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations>


export class RoEthosUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamShortName = new DwItemAttribute(this.i, 'TeamShortName');
    TeamNickName = new DwItemAttribute(this.i, 'TeamNickName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    NameLastFirst = new DwItemAttribute(this.i, 'NameLastFirst');
    NameLastPrefered = new DwItemAttribute(this.i, 'NameLastPrefered');
    NameLastFirstPrefered = new DwItemAttribute(this.i, 'NameLastFirstPrefered');
    NameFirstLast = new DwItemAttribute(this.i, 'NameFirstLast');
    NamePreferedLast = new DwItemAttribute(this.i, 'NamePreferedLast');
    NameFirstPreferedLast = new DwItemAttribute(this.i, 'NameFirstPreferedLast');
    NameFirstMiddleLast = new DwItemAttribute(this.i, 'NameFirstMiddleLast');
    NamePreferedMidInitialLast = new DwItemAttribute(this.i, 'NamePreferedMidInitialLast');
    NameLastFirstPreferedStatus = new DwItemAttribute(this.i, 'NameLastFirstPreferedStatus');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    NameLastFirstPreferedType = new DwItemAttribute(this.i, 'NameLastFirstPreferedType');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    BirthMonthDate = new DwItemAttribute(this.i, 'BirthMonthDate');
    TerritoryId = new DwItemAttribute(this.i, 'TerritoryId');
    TerritoryName = new DwItemAttribute(this.i, 'TerritoryName');
    Company = new DwItemAttribute(this.i, 'Company');
    LicenseCount = new DwItemAttribute(this.i, 'LicenseCount');
    AXId = new DwItemAttribute(this.i, 'AXId');
    YrsService = new DwItemAttribute(this.i, 'YrsService');
    StaffingAgencyName = new DwItemAttribute(this.i, 'StaffingAgencyName');
}

class RoEthosUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId = new DwItemRelationship('roEthos_User|roEthos_User|SupervisorId', 'SupervisorRoEthosUser', 'SupervisorRoEthosUser');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|roEthos_User|UserId', 'EthosUser', 'EthosUser');
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId = new DwItemRelationship('Ethos_User|roEthos_User|SupervisorUserId', 'SupervisorEthosUser', 'SupervisorEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_WachterDepartment|roEthos_User|WachterDepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class RoEthosUserOriginalMetaData implements DwItem2<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2661;
        this.ItemDetail.itemName='roEthos_UserOriginal';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoEthosUserOriginalEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoEthosUserOriginalQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations>(query, this);
    }
     Attributes = new RoEthosUserOriginalMetaDataAttributes();
     Relations = new RoEthosUserOriginalMetaDataRelations();

}


export type RoEthosUserOriginalQueryBuilder = DwQueryBuilderGen<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations>


export class RoEthosUserOriginalMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    AXId = new DwItemAttribute(this.i, 'AXId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    BirthMonthDate = new DwItemAttribute(this.i, 'BirthMonthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    TerritoryId = new DwItemAttribute(this.i, 'TerritoryId');
    TerritoryName = new DwItemAttribute(this.i, 'TerritoryName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamShortName = new DwItemAttribute(this.i, 'TeamShortName');
    TeamNickName = new DwItemAttribute(this.i, 'TeamNickName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    Company = new DwItemAttribute(this.i, 'Company');
    LicenseCount = new DwItemAttribute(this.i, 'LicenseCount');
    NameLastFirst = new DwItemAttribute(this.i, 'NameLastFirst');
    NameLastPrefered = new DwItemAttribute(this.i, 'NameLastPrefered');
    NameLastFirstPrefered = new DwItemAttribute(this.i, 'NameLastFirstPrefered');
    NameFirstLast = new DwItemAttribute(this.i, 'NameFirstLast');
    NamePreferedLast = new DwItemAttribute(this.i, 'NamePreferedLast');
    NameFirstPreferedLast = new DwItemAttribute(this.i, 'NameFirstPreferedLast');
    NameFirstMiddleLast = new DwItemAttribute(this.i, 'NameFirstMiddleLast');
    NamePreferedMidInitialLast = new DwItemAttribute(this.i, 'NamePreferedMidInitialLast');
    NameLastFirstPreferedStatus = new DwItemAttribute(this.i, 'NameLastFirstPreferedStatus');
    NameLastFirstPreferedType = new DwItemAttribute(this.i, 'NameLastFirstPreferedType');
}

class RoEthosUserOriginalMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoProjectKickoffMetaData implements DwItem2<RoProjectKickoffEntity, RoProjectKickoffMetaDataAttributes,RoProjectKickoffMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3430;
        this.ItemDetail.itemName='roProjectKickoff';
        this.ItemDetail.keyName='KickoffId';
    }

    CreateEntity(): RoProjectKickoffEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoProjectKickoffQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoProjectKickoffEntity, RoProjectKickoffMetaDataAttributes,RoProjectKickoffMetaDataRelations>(query, this);
    }
     Attributes = new RoProjectKickoffMetaDataAttributes();
     Relations = new RoProjectKickoffMetaDataRelations();

}


export type RoProjectKickoffQueryBuilder = DwQueryBuilderGen<RoProjectKickoffEntity, RoProjectKickoffMetaDataAttributes,RoProjectKickoffMetaDataRelations>


export class RoProjectKickoffMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roProjectKickoff';
    // Attributes
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    Customer = new DwItemAttribute(this.i, 'Customer');
    JobNumber = new DwItemAttribute(this.i, 'JobNumber');
    ProjectName = new DwItemAttribute(this.i, 'ProjectName');
    ProjectManagerUserId = new DwItemAttribute(this.i, 'ProjectManagerUserId');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    CustomerShortName = new DwItemAttribute(this.i, 'CustomerShortName');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
}

class RoProjectKickoffMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('roProjectKickoff|JobMembership', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('roProjectKickoff|Project_Kickoff|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
    };
export class StakeholderMetaData implements DwItem2<StakeholderEntity, StakeholderMetaDataAttributes,StakeholderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3420;
        this.ItemDetail.itemName='Stakeholder';
        this.ItemDetail.keyName='StakeholderId';
    }

    CreateEntity(): StakeholderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StakeholderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StakeholderEntity, StakeholderMetaDataAttributes,StakeholderMetaDataRelations>(query, this);
    }
     Attributes = new StakeholderMetaDataAttributes();
     Relations = new StakeholderMetaDataRelations();

}


export type StakeholderQueryBuilder = DwQueryBuilderGen<StakeholderEntity, StakeholderMetaDataAttributes,StakeholderMetaDataRelations>


export class StakeholderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Stakeholder';
    // Attributes
    StakeholderId = new DwItemAttribute(this.i, 'StakeholderId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    Name = new DwItemAttribute(this.i, 'Name');
    Title = new DwItemAttribute(this.i, 'Title');
    Role = new DwItemAttribute(this.i, 'Role');
    Department = new DwItemAttribute(this.i, 'Department');
    Company = new DwItemAttribute(this.i, 'Company');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class StakeholderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|Stakeholder|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId = new DwItemRelationship('Ethos_User|Stakeholder|CreatedbyEthos_UserId', 'CreatedbyEthosEthosUser', 'CreatedbyEthosEthosUser');
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId = new DwItemRelationship('Ethos_User|Stakeholder|ModifiedByEthos_UserId', 'ModifiedByEthosEthosUser', 'ModifiedByEthosEthosUser');
    };
export class TeamAssignmentMetaData implements DwItem2<TeamAssignmentEntity, TeamAssignmentMetaDataAttributes,TeamAssignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3418;
        this.ItemDetail.itemName='TeamAssignment';
        this.ItemDetail.keyName='TeamAssignmentId';
    }

    CreateEntity(): TeamAssignmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TeamAssignmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TeamAssignmentEntity, TeamAssignmentMetaDataAttributes,TeamAssignmentMetaDataRelations>(query, this);
    }
     Attributes = new TeamAssignmentMetaDataAttributes();
     Relations = new TeamAssignmentMetaDataRelations();

}


export type TeamAssignmentQueryBuilder = DwQueryBuilderGen<TeamAssignmentEntity, TeamAssignmentMetaDataAttributes,TeamAssignmentMetaDataRelations>


export class TeamAssignmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TeamAssignment';
    // Attributes
    TeamAssignmentId = new DwItemAttribute(this.i, 'TeamAssignmentId');
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    HybridKey = new DwItemAttribute(this.i, 'HybridKey');
}

class TeamAssignmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Kickoff */
            ProjectsKickoff = new DwItemRelationship('projects_Kickoff|TeamAssignment|KickoffId', 'ProjectsKickoff', 'ProjectsKickoff');
    };
// Generated Query Classes for MetaData Service
export class ProjectKickoffAddJobNumberQueryMetaData implements DwItem2<ProjectKickoffAddJobNumberQueryEntity, ProjectKickoffAddJobNumberQueryMetaDataAttributes,EthosJobNumberMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Project_Kickoff_Add_JobNumber';

    constructor() {
        this.ItemDetail.itemId=2375;
        this.ItemDetail.itemName='Ethos_JobNumber';
        this.ItemDetail.keyName='JobNumberId';
    }

    CreateEntity(): ProjectKickoffAddJobNumberQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ProjectKickoffAddJobNumberQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ProjectKickoffAddJobNumberQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ProjectKickoffAddJobNumberQueryEntity, ProjectKickoffAddJobNumberQueryMetaDataAttributes,EthosJobNumberMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ProjectKickoffAddJobNumberQueryMetaDataAttributes();
     Relations = new EthosJobNumberMetaDataRelations();

}


export type ProjectKickoffAddJobNumberQueryBuilder = DwQueryBuilderGen<ProjectKickoffAddJobNumberQueryEntity, ProjectKickoffAddJobNumberQueryMetaDataAttributes,EthosJobNumberMetaDataRelations>


export class ProjectKickoffAddJobNumberQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber';
    // Attributes
    JobNumber = new DwItemAttribute(this.i, 'JobNumber');
    JobNumberStatus = new DwItemAttribute(this.i, 'JobNumberStatus');
    JobName = new DwItemAttribute(this.i, 'JobName');
    ProjectMgr1UserId = new DwItemAttribute(this.i, 'ProjectMgr1UserId');
    ProjectMgr2UserId = new DwItemAttribute(this.i, 'ProjectMgr2UserId');
    EstimatedStartDate = new DwItemAttribute(this.i, 'EstimatedStartDate');
    EstimatedEndDate = new DwItemAttribute(this.i, 'EstimatedEndDate');
    EthosOpportunityOpportunityId = new DwItemAttribute('Ethos_Opportunity', 'EthosOpportunityOpportunityId');
    EthosCustomerCustomerName = new DwItemAttribute('Ethos_Customer', 'EthosCustomerCustomerName');
}
export class ProjectKickoffActiveUnusedJobNumberQueryMetaData implements DwItem2<ProjectKickoffActiveUnusedJobNumberQueryEntity, ProjectKickoffActiveUnusedJobNumberQueryMetaDataAttributes,ProjectsKickoffMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Project_Kickoff-Active_Unused_JobNumber';

    constructor() {
        this.ItemDetail.itemId=3425;
        this.ItemDetail.itemName='projects_Kickoff';
        this.ItemDetail.keyName='KickoffId';
    }

    CreateEntity(): ProjectKickoffActiveUnusedJobNumberQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ProjectKickoffActiveUnusedJobNumberQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ProjectKickoffActiveUnusedJobNumberQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ProjectKickoffActiveUnusedJobNumberQueryEntity, ProjectKickoffActiveUnusedJobNumberQueryMetaDataAttributes,ProjectsKickoffMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ProjectKickoffActiveUnusedJobNumberQueryMetaDataAttributes();
     Relations = new ProjectsKickoffMetaDataRelations();

}


export type ProjectKickoffActiveUnusedJobNumberQueryBuilder = DwQueryBuilderGen<ProjectKickoffActiveUnusedJobNumberQueryEntity, ProjectKickoffActiveUnusedJobNumberQueryMetaDataAttributes,ProjectsKickoffMetaDataRelations>


export class ProjectKickoffActiveUnusedJobNumberQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'projects_Kickoff';
    // Attributes
    KickoffId = new DwItemAttribute(this.i, 'KickoffId');
    EthosJobNumberJobNumberId = new DwItemAttribute('Ethos_JobNumber', 'EthosJobNumberJobNumberId');
    EthosJobNumberJobNumber = new DwItemAttribute('Ethos_JobNumber', 'EthosJobNumberJobNumber');
    EthosJobNumberJobNumberStatus = new DwItemAttribute('Ethos_JobNumber', 'EthosJobNumberJobNumberStatus');
    ProjectName = new DwItemAttribute('Ethos_JobNumber', 'ProjectName');
    StartDate = new DwItemAttribute('Ethos_JobNumber', 'StartDate');
    EndDate = new DwItemAttribute('Ethos_JobNumber', 'EndDate');
    EthosCustomerCustomerName = new DwItemAttribute('Ethos_Customer', 'EthosCustomerCustomerName');
    OpportunityNumber = new DwItemAttribute('Ethos_Opportunity', 'OpportunityNumber');
    PM1Name = new DwItemAttribute('roEthos_User', 'PM1Name');
    PM2Name = new DwItemAttribute('roEthos_User', 'PM2Name');
}


// Generated Query Classes for MetaData Service

class MetaDataQueries {
    ProjectKickoffAddJobNumber : ProjectKickoffAddJobNumberQueryMetaData = new ProjectKickoffAddJobNumberQueryMetaData();
    ProjectKickoffActiveUnusedJobNumber : ProjectKickoffActiveUnusedJobNumberQueryMetaData = new ProjectKickoffActiveUnusedJobNumberQueryMetaData();
}

export class ProjectKickoffMetaData {

    static Billing : BillingMetaData = new BillingMetaData();
    static BillingDepartment : BillingDepartmentMetaData = new BillingDepartmentMetaData();
    static Checklist : ChecklistMetaData = new ChecklistMetaData();
    static Escalation : EscalationMetaData = new EscalationMetaData();
    static EthosCustomer : EthosCustomerMetaData = new EthosCustomerMetaData();
    static EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    static EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    static EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    static EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    static EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    static EthosOpportunity : EthosOpportunityMetaData = new EthosOpportunityMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    static ProjectsKickoff : ProjectsKickoffMetaData = new ProjectsKickoffMetaData();
    static KickoffChecklist : KickoffChecklistMetaData = new KickoffChecklistMetaData();
    static ProjectMilestone : ProjectMilestoneMetaData = new ProjectMilestoneMetaData();
    static Reporting : ReportingMetaData = new ReportingMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoProjectKickoff : RoProjectKickoffMetaData = new RoProjectKickoffMetaData();
    static Stakeholder : StakeholderMetaData = new StakeholderMetaData();
    static TeamAssignment : TeamAssignmentMetaData = new TeamAssignmentMetaData();
    static Queries = new MetaDataQueries();
}
// Generated Entity Interfaces
export interface BillingEntity extends DwOrmData {
    // Attributes
    BillingId?: number;
    KickoffId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    BillingTypeCv?: number;
    JobNumberId?: number;
    ParentJobNumberId?: number;
    InvoiceFrequencyCv?: number;
    EstimatedBillingDate?: string;
    Notes?: string;
    HybridKey?: string;
    InterdepartmentalBilling?: boolean;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    BillingTypeCvDisplay?: string;
    JobNumberIdDisplay?: string;
    ParentJobNumberIdDisplay?: string;
    InvoiceFrequencyCvDisplay?: string;

    // Relations
    ParentEthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    BillingDepartment? : BillingDepartmentEntity[];
}

export interface BillingDepartmentEntity extends DwOrmData {
    // Attributes
    BillingDeptId?: number;
    BillingId?: number;
    WachterDepartmentId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    BillingIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    Billing? : BillingEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface ChecklistEntity extends DwOrmData {
    // Attributes
    ChecklistId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Item?: string;
    Number?: number;

    // Display Attributes
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    KickoffChecklist? : KickoffChecklistEntity[];
}

export interface EscalationEntity extends DwOrmData {
    // Attributes
    EscalationId?: number;
    KickoffId?: number;
    Order?: number;
    Name?: string;
    Title?: string;
    Department?: string;
    Company?: string;
    Phone?: string;
    Email?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Role?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface EthosCustomerEntity extends DwOrmData {
    // Attributes
    CustomerId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    Active?: boolean;


    // Relations
    EndEthosJobNumber? : EthosJobNumberEntity[];
    EthosJobNumber? : EthosJobNumberEntity[];
    EthosOpportunity? : EthosOpportunityEntity[];
    EthosUser? : EthosUserEntity[];
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;
    LookUpKey?: number;
    IsDeleted?: boolean;
    JobNumberTypeCv?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    ForecastStatusCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    JobNumberTypeCvDisplay?: string;

    // Relations
    EndEthosCustomer? : EthosCustomerEntity;
    EthosCustomer? : EthosCustomerEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    ParentBilling? : BillingEntity[];
    Billing? : BillingEntity[];
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    ProjectsKickoff? : ProjectsKickoffEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberMembershipEntity extends DwOrmData {
    // Attributes
    JobNumberMembershipId?: number;
    UserId?: number;
    JobNumberId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    JobNumberIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberPhaseStatusWsDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
}

export interface EthosJobNumberPriorityEntity extends DwOrmData {
    // Attributes
    JobNumberPriorityId?: number;
    JobNumberId?: number;
    PriorityName?: string;
    IsDeleted?: boolean;
    ResponseTimeInHours?: number;
    StraightHourlyBillingRate?: number;
    OvertimeHourlyBillingRate?: number;
    HolidayHourlyBillingRate?: number;
    TravelHourlyBillingRate?: number;
    MileageBillingRate?: number;
    MaxTravelInHours?: number;
    CreatedDateTime?: string;
    CreatedByUserId?: number;
    ModifiedDateTime?: string;
    ModifiedByUserId?: number;
    TripCharge?: number;
    ExpediteFee?: number;
    IsEscalationEnabled?: boolean;
    SendPriorityNotification?: boolean;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosOpportunityEntity extends DwOrmData {
    // Attributes
    OpportunityId?: number;
    OpportunityStatusWs?: number;
    OpportunityName?: string;
    CustomerId?: number;
    ProjectManagerUserId?: number;
    OpportunityManagerUserId?: number;
    ProjectStatusWs?: number;
    StartDate?: string;
    StopDate?: string;

    // Display Attributes
    OpportunityStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    OpportunityManagerUserIdDisplay?: string;
    ProjectStatusWsDisplay?: string;

    // Relations
    EthosCustomer? : EthosCustomerEntity;
    OpportunityManagerEthosUser? : EthosUserEntity;
    ProjectManagerEthosUser? : EthosUserEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    EthosCustomer? : EthosCustomerEntity;
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedbyEthosBilling? : BillingEntity[];
    ModifiedByEthosBilling? : BillingEntity[];
    CreatedbyEthosBillingDepartment? : BillingDepartmentEntity[];
    ModifiedByEthosBillingDepartment? : BillingDepartmentEntity[];
    CreatedbyEthosChecklist? : ChecklistEntity[];
    ModifiedByEthosChecklist? : ChecklistEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    CreatedbyEthosEscalation? : EscalationEntity[];
    ModifiedByEthosEscalation? : EscalationEntity[];
    ProjectMgr1EthosJobNumber? : EthosJobNumberEntity[];
    ProjectMgr2EthosJobNumber? : EthosJobNumberEntity[];
    AsstProjectMgrEthosJobNumber? : EthosJobNumberEntity[];
    SeniorMgrEthosJobNumber? : EthosJobNumberEntity[];
    LeadTech1EthosJobNumber? : EthosJobNumberEntity[];
    LeadTech2EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval1EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval2EthosJobNumber? : EthosJobNumberEntity[];
    CreatedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    ModifiedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    CreatedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    ModifiedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    OpportunityManagerEthosOpportunity? : EthosOpportunityEntity[];
    ProjectManagerEthosOpportunity? : EthosOpportunityEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    DepartmentDirectorEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentAsstManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedbyEthosProjectsKickoff? : ProjectsKickoffEntity[];
    ModifiedByEthosProjectsKickoff? : ProjectsKickoffEntity[];
    LeadTechProjectsKickoff? : ProjectsKickoffEntity[];
    CreatedbyEthosKickoffChecklist? : KickoffChecklistEntity[];
    ModifiedByEthosKickoffChecklist? : KickoffChecklistEntity[];
    CreatedbyEthosProjectMilestone? : ProjectMilestoneEntity[];
    ModifiedByEthosProjectMilestone? : ProjectMilestoneEntity[];
    CreatedbyEthosReporting? : ReportingEntity[];
    ModifiedByEthosReporting? : ReportingEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    CreatedbyEthosStakeholder? : StakeholderEntity[];
    ModifiedByEthosStakeholder? : StakeholderEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentTypeCvDisplay?: string;
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberPhaseIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    DepartmentDirectorEthosUser? : EthosUserEntity;
    DepartmentManagerEthosUser? : EthosUserEntity;
    DepartmentAsstManagerEthosUser? : EthosUserEntity;
    BillingDepartment? : BillingDepartmentEntity[];
    EthosUser? : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity[];
}

export interface ProjectsKickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    LeadTimeWts?: string;
    StageTime?: string;
    ConfigurationTime?: string;
    CustomerSpoc?: string;
    FollowUpMeetings?: string;
    Ppe?: string;
    SpecialRequirements?: string;
    QualityProgramDetails?: string;
    Scope?: string;
    Deliverables?: string;
    RequiresEquipOrValidation?: boolean;
    ValidationNotes?: string;
    ChangeOrderPlan?: string;
    CopResponsibility?: string;
    HelpDesk?: boolean;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    CompletionDate?: string;
    IsCriticalCare?: boolean;
    ExternalDueDate?: string;
    PermittingProcess?: string;
    BudgetHours?: number;
    IsLicensedRequired?: boolean;
    LeadTechUserId?: number;
    JobNumberId?: number;
    ParentKickoffId?: number;
    LicensingRequired?: string;
    HelpContactDetails?: string;

    // Display Attributes
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    LeadTechUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    ParentKickoffIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ParentProjectsKickoff? : ProjectsKickoffEntity[];
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    LeadTechEthosUser? : EthosUserEntity;
    Billing? : BillingEntity[];
    Escalation? : EscalationEntity[];
    KickoffChecklist? : KickoffChecklistEntity[];
    // Duplicate property excluded
    // ParentProjectsKickoff : ProjectsKickoffEntity;
    ProjectMilestone? : ProjectMilestoneEntity[];
    Reporting? : ReportingEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
    Stakeholder? : StakeholderEntity[];
    TeamAssignment? : TeamAssignmentEntity[];
}

export interface KickoffChecklistEntity extends DwOrmData {
    // Attributes
    KickoffChecklistId?: number;
    KickoffId?: number;
    ChecklistId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    ChecklistIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    Checklist? : ChecklistEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface ProjectMilestoneEntity extends DwOrmData {
    // Attributes
    ProjectMilestoneId?: number;
    KickoffId?: number;
    Name?: string;
    Description?: string;
    StartDate?: string;
    EndDate?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface ReportingEntity extends DwOrmData {
    // Attributes
    ReportingId?: number;
    KickoffId?: number;
    Name?: string;
    Owner?: string;
    Recipient?: string;
    Contents?: string;
    Frequency?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoProjectKickoffEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    Customer?: string;
    JobNumber?: string;
    ProjectName?: string;
    ProjectManagerUserId?: number;
    StartDate?: string;
    EndDate?: string;
    KickoffId?: number;
    CustomerId?: number;
    CustomerShortName?: string;
    SupervisorUserId?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    KickoffIdDisplay?: string;
    CustomerIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
}

export interface StakeholderEntity extends DwOrmData {
    // Attributes
    StakeholderId?: number;
    KickoffId?: number;
    Name?: string;
    Title?: string;
    Role?: string;
    Department?: string;
    Company?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface TeamAssignmentEntity extends DwOrmData {
    // Attributes
    TeamAssignmentId?: number;
    KickoffId?: number;
    WachterTeamId?: number;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    WachterTeamIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
}

// Generated Query Interfaces
/** Entity for Query Meaning Project_Kickoff_Add_JobNumber  */
export interface ProjectKickoffAddJobNumberQueryEntity extends DwOrmData {
    // Attributes
    JobNumber?: string;
    JobNumberStatus?: string;
    JobName?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr1UserIdDisplay?: number;
    ProjectMgr2UserId?: number;
    ProjectMgr2UserIdDisplay?: number;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    EthosOpportunityOpportunityId?: number;
    EthosCustomerCustomerName?: string;

    // Relations
    EndEthosCustomer? : EthosCustomerEntity;
    EthosCustomer? : EthosCustomerEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    ParentBilling? : BillingEntity[];
    Billing? : BillingEntity[];
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    ProjectsKickoff? : ProjectsKickoffEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
}

/** Entity for Query Meaning Project_Kickoff-Active_Unused_JobNumber  */
export interface ProjectKickoffActiveUnusedJobNumberQueryEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    EthosJobNumberJobNumberId?: number;
    EthosJobNumberJobNumber?: string;
    EthosJobNumberJobNumberStatus?: string;
    ProjectName?: string;
    StartDate?: string;
    EndDate?: string;
    EthosCustomerCustomerName?: string;
    OpportunityNumber?: number;
    PM1Name?: string;
    PM2Name?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ParentProjectsKickoff? : ProjectsKickoffEntity[];
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    LeadTechEthosUser? : EthosUserEntity;
    Billing? : BillingEntity[];
    Escalation? : EscalationEntity[];
    KickoffChecklist? : KickoffChecklistEntity[];
    // Duplicate property excluded
    // ParentProjectsKickoff : ProjectsKickoffEntity;
    ProjectMilestone? : ProjectMilestoneEntity[];
    Reporting? : ReportingEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
    Stakeholder? : StakeholderEntity[];
    TeamAssignment? : TeamAssignmentEntity[];
}



